"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBuyFormCallback = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const useControlledValuesRef_1 = require("../_hooks/useControlledValuesRef");
function isDraftFunction(valOrUpdater) {
    return typeof valOrUpdater === 'function';
}
function buyFormCallback({ effectiveValues_, setCurrentValues, }, fn, args) {
    const intf = {
        set: (valOrUpdater) => {
            if (isDraftFunction(valOrUpdater)) {
                setCurrentValues === null || setCurrentValues === void 0 ? void 0 : setCurrentValues(valOrUpdater);
            }
            else {
                setCurrentValues === null || setCurrentValues === void 0 ? void 0 : setCurrentValues(draft => {
                    if (valOrUpdater instanceof Object) {
                        Object.keys(valOrUpdater).forEach(paramKey => {
                            draft[paramKey] = valOrUpdater[paramKey];
                        });
                    }
                });
            }
        },
        reset: (paramKey) => {
            if (paramKey) {
                setCurrentValues === null || setCurrentValues === void 0 ? void 0 : setCurrentValues(draft => {
                    delete draft[paramKey];
                });
            }
            else {
                setCurrentValues === null || setCurrentValues === void 0 ? void 0 : setCurrentValues(draft => {
                    Object.keys(draft).forEach(key => {
                        delete draft[key];
                    });
                });
            }
        },
        snapshot: {
            getPromise: () => (effectiveValues_ ? (0, rxjs_1.firstValueFrom)(effectiveValues_) : Promise.resolve({})),
        },
    };
    return fn(intf)(...args);
}
function useBuyFormCallback(fn, deps = []) {
    const controlledValuesRef = (0, useControlledValuesRef_1.useControlledValuesRef)();
    return (0, react_1.useCallback)((...args) => {
        var _a, _b;
        return buyFormCallback({
            effectiveValues_: (_a = controlledValuesRef === null || controlledValuesRef === void 0 ? void 0 : controlledValuesRef.effectiveValues_) === null || _a === void 0 ? void 0 : _a.current,
            setCurrentValues: (_b = controlledValuesRef === null || controlledValuesRef === void 0 ? void 0 : controlledValuesRef.setCurrentValues) === null || _b === void 0 ? void 0 : _b.current,
        }, fn, args);
    }, [...deps, controlledValuesRef === null || controlledValuesRef === void 0 ? void 0 : controlledValuesRef.effectiveValues_, controlledValuesRef === null || controlledValuesRef === void 0 ? void 0 : controlledValuesRef.setCurrentValues]);
}
exports.useBuyFormCallback = useBuyFormCallback;
